// React
import { useEffect, useState } from "react"

// Types
import type { SelectOptionType, SuccessFetch } from "types"

// Utils
import { useApi } from "utils"

export function useGroupList(): {
  data: SelectOptionType[]
  isLoading: boolean
} {
  // Hooks
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    api.get(
      "/productgroup/"
    ).then((res: SuccessFetch<{
      payload: {
        mr_product_group_id: number
        mr_product_group_name: string
      }[]
    }>) => {
      setData(res.data.payload.map(item => ({
        label: item.mr_product_group_name,
        value: item.mr_product_group_id.toString()
      })))
    }).catch(() => {
      setData([])
    }).finally(() => {
      // Vars
      const defaultData: SelectOptionType = {
        label: "All",
        value: ""
      }

      setData(prev => [defaultData, ...prev])
      setLoading(false)
    })

    return () => {
      setData([])
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  return { data, isLoading }
}